import getCategories from './util/getCategories'
import getSkincareCollections from './util/getSkincareCollections'

import messages from './messages'


const getNavStructureMobileNew = ({ root, structure, collections }) =>
  structure.reduce((newStructure, { children, name, url: to, productsQuery: { gender } }) => {
    const categories = getCategories({ routes: children, withSubNav: true})
    const seeAllItem = {
      title: messages.seeAll, // for consistent with other 'see all' links
      to,
      dataTestId: name,
    }

    if (root === 'skincare') {
      const collectionsItem = getSkincareCollections({ gender, collections })

      newStructure.push(
        {
          title: gender === 'male' ? messages.men : messages.women,
          isSeparator: true,
        },
        seeAllItem,
        collectionsItem,
      )
    }
    else {
      newStructure.push(seeAllItem)
    }

    newStructure.push(...categories)

    return newStructure
  }, [])


export default getNavStructureMobileNew
